import EtHeader from "@/components/navigation/EtHeader";
import EtFooter from "@/components/navigation/EtFooter";

import EtEternityHero from "@/components/sections/EtEternityHero";
import EtEternityMission from "@/components/sections/EtEternityMission";
import EtEternitySolutions from "@/components/sections/EtEternitySolutions";
import EtEternityClientsInvestors from "@/components/sections/EtEternityClientsInvestors";
import EtEternityClients from "@/components/sections/EtEternityClients";
import EtEternityCTA from "@/components/sections/EtEternityCTA";

import EtTestimonials from "@/components/sections/EtTestimonials"; // reuse existing
import EtContact from "@/components/sections/EtContact"; // reuse existing

// 20 Nov 2025
import {useState, useEffect} from "react"

export default function EtEternityHome() {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey
  // Updated - 08 Oct 2025 - changed the comp from EtEternityClientsInvestors to EtEternityClients
  // Updated - 10 Oct 2025 - commented EtContact - will be launched from EtEternityCTA
  // Updated - 20 Nov 2025 - scroll control

  // 1 - Scroll to top on reload - 20 Nov 2025
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    useEffect(() => {
      if (typeof window !== "undefined") {
        const hash = window.location.hash;
        if (hash) {
          const el = document.querySelector(hash);
          if (el) {
            setTimeout(() => {
              el.scrollIntoView({ behavior: "smooth" });
            }, 100); 
          }
        }
      }
    }, []);
  

  return (
    <div className="font-poppins">
      {/* Global Header */}
      <EtHeader variant="eternity"/>

      {/* Page Sections */}
      <EtEternityHero />
      <EtEternityMission />
      <EtEternitySolutions />
      {/* <EtEternityClientsInvestors /> */}
      <EtEternityClients />
      <EtTestimonials />
      <EtEternityCTA />
      {/* <EtContact /> */}

      {/* Global Footer */}
      <EtFooter variant="eternity"/>
    </div>
  );
}
